import { shopStore } from '@/store/shop'

interface IPerssion {
    [key: string]: string
}

export const pcPerssion: IPerssion = {
    1: '进入零售后台', // 零售后台权限
    3: '店铺数据',
    4: '会员管理',
    5: '店铺设置',
    9: '订单退款',
    10: '添加/删除商品',
    11: '商品上/下架',
}

export const cashierPerssion: IPerssion = {
    2: '进入收银台', // 收银台权限
    12: '永久改价',
    54: '临时改价/单品优惠',
    13: '订单减免',
    14: '收银台退款',
    15: '订单折扣',
    16: '订单抹零',
    29: '查看收银数据',
    36: '极速收银',
    41: '结算前打印小票',
    53: '删除挂单',
    57: '修改充值赠送金额',
}

export const lsPerssion: () => IPerssion = () => {
    const perssion = {
        // 0: '超管',
        17: '进入App权限', // app 权限
        6: '添加员工',
        7: '删除员工',
        8: '编辑/配置角色',
        30: '查看商品进价', // 删除商品进价
        18: '店铺数据',
        19: '编辑会员信息',
        20: '店铺设置',
        21: '添加员工',
        22: '删除员工',
        // 23: "编辑/配置角色",
        24: '订单退款',
        25: '添加/删除商品',
        26: '商品上/下架',
        28: '删除手工会员',
        35: '创建优惠券',
        38: '创建满减减送', // 满减减送
        31: '采购单', // 零售通查看采购单
        34: '手动充值会员',
        37: '创建限时折扣',
        39: '成本价编辑/查看',
        40: '库存查询',
        42: '改价',
        43: '库存盘点',
        44: '商品报损',
        45: '查看员工操作记录',
        46: '编辑员工',
        47: '更改会员等级',
        48: '社区团购-处理团长申请',
        49: '开关社区团购模块',
        50: '更改会员积分',
        58: '库存调拨',
    }

    if ([2, 3].includes(shopStore.shopInfo?.wsc_version || 0)) {
        return {
            ...perssion,
            33: '订单导出',
        }
    } else {
        return perssion
    }
}
